import floatingButton from './components/floating-button/floating-button';
import service from './services/common.service';
import message from './services/message.service';
import {environment} from './environments/evironment';
/**
 * Main function that starts the application
 * @param _
 * @returns {Promise<void>}
 */
const start = async _ => {
    console.log('Digital Gate V2 - Start...');

    let accountKey;
    let config;
    //AQUI INICIALIZA CUENTA_ID
    window.dgAccountKey = environment.ACCOUNTKEY;

    setTimeout(_ => {
        accountKey = window.dgAccountKey;
        config = service.getAccountConfig(accountKey);

        config.onload = function () {
            if (this.status === 200) {
                let settings = JSON.parse(this.responseText);
                floatingButton.render(settings["Result"]);
                message.messagesListener();
                window.channels.showBubble(true);
            } else {
                console.log('Failed to get settings');
            }
        };
    }, 1000);

    console.log('Digital Gate V2 - Complete');
};

start();

